export default {
      id: "md_mileage-usage",
      viewBox: "0 0 18 17",
      url: __webpack_public_path__ + "img/icons.svg#md_mileage",
      toString: function () {
        return this.url;
      }
    }